import {useTranslation} from 'lib/i18n';
import {useMemo} from 'react';

export default function useMaritalStatusOptions() {
  const {t} = useTranslation();

  return useMemo(() => t('inputsTranslation:borrower info.marital status options', {returnObjects: true}), [t]);
}
